import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home'
import Register from '@/components/Register'
import RegisterSuccess from '@/components/RegisterSuccess'
import SampleReports from '@/components/SampleReports'
import BuyReports from '@/components/BuyReports'
import NewBook from '@/components/NewBook'
import BookDetailsPage from '@/components/BookDetailsPage'
import Account from '@/components/Account'
import Logout from '@/components/Logout'
import About from '@/components/About'
import Contact from '@/components/Contact'
import FAQ from '@/components/FAQ'
import Orders from '@/components/Orders'
import Feedback from '@/components/Feedback'
import Oops from '@/components/Oops'
import ToolsNAICS from '@/components/ToolsNAICS'
import ViewReport from '@/components/ViewReport'
import OrderConfirmation from '@/components/OrderConfirmation'
import Checkout from '@/components/Checkout'

import store from "../store";

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next();
    return;
  }
  next("/");
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
    return;
  }
  next("/login");
};


let router = new Router({
	routes: [
		{
			path: '/',
			name: 'Home',
			component: Home,
		},
		{
			path: '/login',
			name: 'Login',
			component: Login
		},
    {
			path: '/about',
			name: 'About',
			component: About
		},
    {
			path: '/contact',
			name: 'Contact',
			component: Contact
		},
        {
			path: '/logout',
			name: 'Logout',
			component: Logout
		},
    {
  path: '/faq',
  name: 'FAQ',
  component: FAQ
},
    {
			path: '/register',
			name: 'Register',
			component: Register
		},
		{
			path: '/registersuccess',
			name: 'RegisterSuccess',
			component: RegisterSuccess
		},
		{
			path: '/samplereports',
			name: 'SampleReports',
			component: SampleReports
		},
		{
			path: '/buyreports',
			name: 'BuyReports',
			component: BuyReports
		},
		{
			path: '/add-book',
			name: 'NewBook',
			component: NewBook,
			meta: {
				requiresAuth: false
			}
		},
		{
	path: "/account",
	name: "Account",
	component: Account
},
{
path: "/toolsnaics",
name: "ToolsNAICS",
component: ToolsNAICS
},
{
path: "/orders",
name: "Orders",
component: Orders
},
{
path: "/oops",
name: "Oops",
component: Oops
},
{
path: "/viewreport",
name: "ViewReport",
component: ViewReport
},
{
path: "/orderconfirmation",
name: "OrderConfirmation",
component: OrderConfirmation
},
{
path: "/checkout",
name: "Checkout",
component: Checkout
},
{
path: "/feedback",
name: "Feedback",
component: Feedback
},
		{
			path: '/book-detail',
			name: 'BookDetailsPage',
			component: BookDetailsPage,
			props: true,
			meta: {
				requiresAuth: false
			}
		}
	]
})

router.beforeEach((to, from, next) => {

	let currentUser = JSON.parse(localStorage.getItem('currentUser'));

	let requiresAuth = to.matched.some(record => record.meta.requiresAuth);

	if (requiresAuth && !currentUser) {
		next('/')
	} else if (!requiresAuth && currentUser) {
		next('home')
	} else {
		next()
	}

})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js